/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { isSameArrayOfObjs } from '../../common/helpers';
import { useFormDocs } from '../../hooks';
import useServerLang from '../../hooks/useServerLang';
import Auth from '../auth';
import Content from './Content';
import EmplContent from './EmplContent';

const Layout = ({
  user,
  lang,
  languages,
  setLanguages,
  formdocs,
  setFormdocs,
}: any) => {
  const isEmployee = user?.isEmployee;
  const { ar, en, updatedAt } = useServerLang();
  const { formdocs: formdocsdata } = useFormDocs();
  useEffect(() => {
    if (
      ar &&
      en &&
      lang &&
      (!languages?.updatedAt || languages?.updatedAt !== updatedAt)
    ) {
      setLanguages({ ar, en, updatedAt });
      window.location.reload();
    }
  }, [lang, ar, en, updatedAt]);
  useEffect(() => {
    if (
      formdocsdata &&
      formdocsdata?.length > 0 &&
      !isSameArrayOfObjs(formdocsdata, formdocs)
    ) {
      setFormdocs(formdocsdata);
      window.location.reload();
    }
  }, [formdocsdata]);
  return (
    <BrowserRouter>
      {!user && <Auth></Auth>}
      {user && !isEmployee && (
        <Content isEmployee={false} formdocs={formdocs}></Content>
      )}
      {user && isEmployee && <EmplContent isEmployee={true}></EmplContent>}
    </BrowserRouter>
  );
};
export default Layout;
